import { mapKeys, mapValues } from 'lodash';
import { wrap } from 'svelte-spa-router/wrap';
import { user } from '../store';
import { Role } from '../modules/user/user.interface';
export function wrapWithProps(routeDefinition, props, ignorePaths) {
    const routeDefs = mapValues(routeDefinition, (component, routePath) => {
        if (ignorePaths === null || ignorePaths === void 0 ? void 0 : ignorePaths.includes(routePath)) {
            return component;
        }
        return wrap({
            component,
            props,
        });
    });
    return routeDefs;
}
export function createRoutesWithPrefix(routePrefix, routes) {
    const r = mapKeys(routes, (_, key) => {
        return `${routePrefix}${key}`;
    });
    return r;
}
export function addAuthGuard(routeDefinition) {
    const routeDefs = mapValues(routeDefinition, (component, routePath) => {
        if (routePath === '/login') {
            return component;
        }
        return wrap({
            component,
            conditions: [authCondition],
        });
    });
    return routeDefs;
}
function authCondition() {
    const currentUser = user.getUserSync();
    if (!currentUser || ![Role.EDITOR, Role.ADMIN].includes(currentUser.role))
        return false;
    return true;
}
